import { theme, breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const DrawerTitleContainer = styled.div`
  position: relative;
  z-index: 4;
  width: 100%;
  box-shadow: 0px 2px 4px 0px rgba(71, 71, 71, 0.08),
    0px 1px 2px 0px rgba(71, 71, 71, 0.04);
`;

export const StyledDrawerTitle = styled.span`
  padding: 1rem 1rem 1rem 0;
  ${theme.typography.labelLarge}
`;

export const DrawerIconWrapper = styled.div`
  width: 100%;
  text-align: center;

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export const DrawerDragger = styled.div`
  position: absolute;
  width: 2rem;
  height: 0.25rem;
  left: calc(50% - 2rem / 2 - 0.5px);
  top: 0.5rem;
  background: ${theme.color.border.divider};
  border-radius: 6.25rem;
`;

export const DrawerTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseIconButton = styled.button`
  background-color: rgba(0, 0, 0, 0);
  border: none;
  padding: 1rem;
  cursor: pointer;
`;

export const RefreshButton = styled.a`
  display: inline-block;
  padding: 1rem;
  margin-left: auto;
  text-decoration: none;
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.tertiary};
  cursor: pointer;
`;
